import { MutableRefObject, useRef } from 'react';

import { IbInstallmentsServicesTypes } from '../../services/IbInstallmentsServices/APIService';
import { IbInstallmentsServices } from '../../services/IbInstallmentsServices/APIService/index.api';
import { networkCallWithApisauceWithHeaders } from '../../utils/AuthAPIUtils';

import { usePaymentsRefreshAuthTokens } from '../usePaymentsRefreshAuthTokens';

interface IbInstallmentsServiceInstance {
  ibInstallmentsServiceInstance: IbInstallmentsServicesTypes;
}

const useIbInstallmentsService = (): IbInstallmentsServiceInstance => {
  const { refreshTokenApi, getRefreshToken, getAccessToken } =
    usePaymentsRefreshAuthTokens();
  const ibInstallmentsServiceRef: MutableRefObject<IbInstallmentsServicesTypes | null> =
    useRef(null);

  if (ibInstallmentsServiceRef.current === null) {
    ibInstallmentsServiceRef.current = new IbInstallmentsServices(
      networkCallWithApisauceWithHeaders({
        refreshAuthTokensAPI: refreshTokenApi,
        getAccessToken,
        getRefreshToken
      })
    );
  }

  return { ibInstallmentsServiceInstance: ibInstallmentsServiceRef.current };
};

export { useIbInstallmentsService };
